import { Injectable } from '@angular/core';
import { AbstractPlayButtonSpinnerService } from 'osn-shared';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MockPlayButtonSpinnerService extends AbstractPlayButtonSpinnerService {
  public readonly showLoadingSpinner$: Observable<boolean> = of(false);
}
